export default {
  title: '¡No te lo pierdas!',
  description: 'Activa las notificaciones para estar al tanto de tu pedido.',
  buttons: {
    enable: 'Activar',
  },
};
